module.exports = {
	"VCT": "NA",
	"PER": "SA",
	"GEO": "AS",
	"SLE": "AF",
	"AGO": "AF",
	"GNB": "AF",
	"STP": "AF",
	"NIU": "OC",
	"CIV": "AF",
	"AFG": "AS",
	"VAT": "EU",
	"BLZ": "NA",
	"BGD": "AS",
	"SHN": "AF",
	"BHS": "NA",
	"MYS": "AS",
	"RWA": "AF",
	"LTU": "EU",
	"CZE": "EU",
	"ESH": "AF",
	"CYM": "NA",
	"BES": "NA",
	"BTN": "AS",
	"ARE": "AS",
	"IRQ": "AS",
	"COG": "AF",
	"UMI": "OC",
	"HKG": "AS",
	"VGB": "NA",
	"VEN": "SA",
	"COM": "AF",
	"PYF": "OC",
	"BRB": "NA",
	"NGA": "AF",
	"LUX": "EU",
	"NZL": "OC",
	"TGO": "AF",
	"LAO": "AS",
	"CCK": "AS",
	"TWN": "AS",
	"ZMB": "AF",
	"PRK": "AS",
	"QAT": "AS",
	"BIH": "EU",
	"TUV": "OC",
	"SYR": "AS",
	"ZWE": "AF",
	"ATA": "AN",
	"LBN": "AS",
	"BDI": "AF",
	"MDG": "AF",
	"BGR": "EU",
	"ISR": "AS",
	"UGA": "AF",
	"LKA": "AS",
	"AUS": "OC",
	"HRV": "EU",
	"EST": "EU",
	"EGY": "AF",
	"UKR": "EU",
	"REU": "AF",
	"GMB": "AF",
	"TKL": "OC",
	"NER": "AF",
	"FLK": "SA",
	"IDN": "AS",
	"GAB": "AF",
	"NCL": "OC",
	"CUB": "NA",
	"LCA": "NA",
	"PRI": "NA",
	"MHL": "OC",
	"JOR": "AS",
	"SYC": "AF",
	"ETH": "AF",
	"UZB": "AS",
	"DMA": "NA",
	"BRA": "SA",
	"SRB": "EU",
	"BFA": "AF",
	"YEM": "AS",
	"DOM": "NA",
	"MAC": "AS",
	"JAM": "NA",
	"MYT": "AF",
	"DJI": "AF",
	"ISL": "EU",
	"SVN": "EU",
	"ITA": "EU",
	"HMD": "AN",
	"AUT": "EU",
	"AND": "EU",
	"WSM": "OC",
	"SLB": "OC",
	"BRN": "AS",
	"KWT": "AS",
	"SGS": "AN",
	"ATG": "NA",
	"TON": "OC",
	"FRA": "EU",
	"COL": "SA",
	"FJI": "OC",
	"LBR": "AF",
	"CAN": "NA",
	"IRL": "EU",
	"NLD": "EU",
	"IOT": "AS",
	"HND": "NA",
	"ESP": "EU",
	"TUR": "AS",
	"NFK": "OC",
	"PLW": "OC",
	"KNA": "NA",
	"IRN": "AS",
	"CXR": "AS",
	"MTQ": "NA",
	"JPN": "AS",
	"KHM": "AS",
	"PCN": "OC",
	"KEN": "AF",
	"VNM": "AS",
	"TJK": "AS",
	"GNQ": "AF",
	"TTO": "NA",
	"JEY": "EU",
	"RUS": "EU",
	"USA": "NA",
	"FSM": "OC",
	"SOM": "AF",
	"PRT": "EU",
	"BLR": "EU",
	"MOZ": "AF",
	"PAK": "AS",
	"MLI": "AF",
	"AZE": "AS",
	"CHE": "EU",
	"GUF": "SA",
	"GHA": "AF",
	"SWE": "EU",
	"CMR": "AF",
	"COK": "OC",
	"BOL": "SA",
	"TUN": "AF",
	"MCO": "EU",
	"ABW": "NA",
	"GRD": "NA",
	"NOR": "EU",
	"NRU": "OC",
	"PSE": "AS",
	"CPV": "AF",
	"SSD": "AF",
	"IMN": "EU",
	"ARG": "SA",
	"GIN": "AF",
	"GIB": "EU",
	"ALA": "EU",
	"CHL": "SA",
	"SUR": "SA",
	"CHN": "AS",
	"SPM": "NA",
	"BLM": "NA",
	"VUT": "OC",
	"GTM": "NA",
	"HUN": "EU",
	"SJM": "EU",
	"MRT": "AF",
	"GUY": "SA",
	"MDV": "AS",
	"WLF": "OC",
	"TKM": "AS",
	"GRL": "NA",
	"ERI": "AF",
	"PHL": "AS",
	"SGP": "AS",
	"ALB": "EU",
	"KAZ": "AS",
	"URY": "SA",
	"ROU": "EU",
	"BHR": "AS",
	"MAF": "NA",
	"LBY": "AF",
	"COD": "AF",
	"MEX": "NA",
	"CRI": "NA",
	"NAM": "AF",
	"MWI": "AF",
	"CYP": "EU",
	"BEN": "AF",
	"ASM": "OC",
	"SEN": "AF",
	"MAR": "AF",
	"TZA": "AF",
	"GBR": "EU",
	"PRY": "SA",
	"MMR": "AS",
	"LIE": "EU",
	"SLV": "NA",
	"BMU": "NA",
	"DNK": "EU",
	"DZA": "AF",
	"FRO": "EU",
	"ZAF": "AF",
	"MKD": "EU",
	"DEU": "EU",
	"MNP": "OC",
	"POL": "EU",
	"NPL": "AS",
	"IND": "AS",
	"KGZ": "AS",
	"ARM": "AS",
	"CAF": "AF",
	"CUW": "NA",
	"ATF": "AN",
	"BEL": "EU",
	"MUS": "AF",
	"GLP": "NA",
	"TLS": "OC",
	"ECU": "SA",
	"MDA": "EU",
	"TCA": "NA",
	"GUM": "OC",
	"FIN": "EU",
	"THA": "AS",
	"SVK": "EU",
	"BWA": "AF",
	"SMR": "EU",
	"PNG": "OC",
	"BVT": "AN",
	"LVA": "EU",
	"HTI": "NA",
	"AIA": "NA",
	"MNG": "AS",
	"SDN": "AF",
	"OMN": "AS",
	"GGY": "EU",
	"SWZ": "AF",
	"TCD": "AF",
	"MLT": "EU",
	"GRC": "EU",
	"MSR": "NA",
	"PAN": "NA",
	"NIC": "NA",
	"VIR": "NA",
	"SAU": "AS",
	"KIR": "OC",
	"SXM": "NA",
	"KOR": "AS",
	"LSO": "AF",
	"MNE": "EU"
};


//////////////////
// WEBPACK FOOTER
// ./src/data/countries_continents.json
// module id = 586
// module chunks = 0